import Histogram from "../components/Histogram";

function HistogramWrap({ className = "" }) {
  return (
    <div className={`flex-col items-center justify-end hidden 2xl:flex ${className}`}>
      <Histogram />
    </div>
  );
}

export default HistogramWrap;